const callCenter = {
  path: '/callCenter', //主体
  name: 'callCenter',
  redirect: '/customerInfo',
  component: () => import('@/views/callCenter/main'),
  children: []
}

export default callCenter
